<template>
    <div class="window-wrapper" v-show="visible">
        <div class="window delete-article-window" v-show="visible">
            <div class="window-head">
                <div class="title">Удалить статью
                    <span class="close"
                          @click="closeWindow"><img src="@/image/close.png"></span>
                </div>
            </div>
            <div class="window-body">
                <div class="text">Вы действительно хотите удалить статью<br>"{{ name }}"?</div>
                <div class="center two-buttons">
                    <button class="button red-button" type="button"
                            @click="sendDeleteRequest">Да
                    </button>
                    <button class="button blue-button" type="button"
                            @click="closeWindow">Нет
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from '@/utils';

    export default {
        name: "DeleteArticleWindow",

        props: ['visible', 'id', 'name'],

        data() {
            return {}
        },

        watch: {
            visible(val) {
                utils.changePopupWindowVisibility(val);
            }
        },

        computed: {},

        methods: {
            async sendDeleteRequest() {
                let success = await this.$store.dispatch('deleteArticle', Number(this.id));
                if (success)
                    this.$emit('close-window', {
                        reload: true
                    });
            },

            closeWindow() {
                this.$emit('close-window', {
                    reload: false
                });
            }
        },

        destroyed() {
            utils.changePopupWindowVisibility(false);
        }
    }
</script>